<template>
  <div>
    <!-- 联系人 -->
    <div class="contact">
      <div @click="selectContact()">
        <Button
          type="primary"
          v-hasPermission="['alarm_contact:AlarmContactGroup:create']"
          @click="modal = true"
          >{{ $t("alarm_contact.addAlarmContact") }}</Button
        >
      </div>
    </div>
    <Modal
      v-model="modal"
      :title="$t('alarm_contact.addAlarmContact')"
      width="900px;"
      :loading="modalLoading"
      ok-text="添加"
      :mask-closable="false"
      :closable="false"
    >
      <div slot="footer">
        <Button @click="cancel()">{{ $t("alarms.common.cancel") }}</Button>
        <Button
          type="primary"
          @click="handleSubmit()"
          :loading="addloading"
          :disabled="isDisable"
          >{{ $t("alarms.common.add") }}</Button
        >
      </div>
      <Table
        :no-data-text="$t('common.noData')"
        ref="selection"
        :columns="columns"
        :loading="loading"
        :data="queryData"
        :height="400"
        @on-selection-change="getSelection"
      ></Table>
    </Modal>
    <table-contact-configuration></table-contact-configuration>
  </div>
</template>

<script>
import { getCookie } from "../../../../utils/cookieUtil.js";
import TableContactConfiguration from "../contact_configuration/TableContactConfiguration";

var tableContactConfiguration = TableContactConfiguration;
export default {
  name: "AddContactConfiguration",
  components: {
    TableContactConfiguration
  },
  data() {
    return {
      selection: [],
      modal: false,
      modalLoading: true,
      loading: false,
      addloading: false,
      isDisable: true,
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: this.$t("alarm_contact.name"),
          key: "name"
        },
        {
          title: this.$t("alarm_contact.dept"),
          key: "dept"
        },
        {
          title: this.$t("alarm_contact.position"),
          key: "position"
        },
        {
          title: this.$t("alarm_contact.monitorModule"),
          key: "monitorModuleName"
        },
        {
          title: this.$t("alarm_contact.email"),
          key: "email"
        }
      ],
      queryData: [],
      newQueryList: []
    };
  },
  methods: {
    selectContact: function() {
      this.$api.contact
        .listContactsNotInContactGroup({
          contactGroupId: this.$route.query.id
        })
        .then(res => {
          this.queryData = res.data;
        });
    },
    // 当前选择checkbox
    getSelection: function(selection) {
      this.selection = selection;
      // 清空数组
      this.newQueryList = [];
      for (var i = 0; i < this.selection.length; i++) {
        this.newQueryList.push(this.selection[i].id);
      }

      // 选了数据 可以点击下一步
      if (this.newQueryList.length == 0) {
        this.isDisable = true;
      } else {
        this.isDisable = false;
      }
    },
    // 添加
    handleSubmit: function() {
      this.addloading = true;
      this.$api.contactGroup
        .batchCreate({
          contactGroupId: this.$route.query.id,
          contactIds: this.newQueryList
        })
        .then(res => {
          setTimeout(() => {
            tableContactConfiguration.methods.showAllUser();
            this.modalLoading = false;
            this.$nextTick(() => {
              this.modalLoading = true;
            });
            this.$Message.success("添加成功");
            this.queryData = [];
            this.newQueryList = [];
            this.modal = false;
            this.isDisable = true;
            this.addloading = false;
          }, 1000);
        });
    },
    // 取消
    cancel: function() {
      this.isDisable = true;
      this.modal = false;
      this.queryData = [];
      this.newQueryList = [];
    }
  }
};
</script>

<style scoped>
.contact {
  width: 100%;
  margin-bottom: 10px;
  overflow: hidden;
}

.contact > div:nth-child(1) {
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/alarm_contact/alarm_contact_group/contact_configuration/AddContactConfiguration.vue